import { Component, Event, EventEmitter, Prop, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-radio-button',
  styleUrl: 'lab-ds-radio-button.css',
  shadow: true,
})
export class LabDsRadioButton {
  @Event() handleRadioButton: EventEmitter;

  handleClick() {
    this.handleRadioButton.emit(this.checked);
  }

  @Prop() label!: string;

  @Prop() avatar: boolean = false;

  @Prop() error: boolean = false;

  @Prop() disabled: boolean = false;

  @Prop() checked: boolean = false;

  render() {
    return (
      <label class={`container ${this.disabled ? 'disabled' : ''}`}>
        <input checked={this.checked} onClick={() => this.handleClick()} disabled={this.disabled} type="radio" />
        {this.avatar ? <lab-ds-avatar size="small" /> : null}
        <span class={`label-text ${this.checked ? 'checked' : ''}`}>{this.label}</span>
      </label>
    );
  }
}
